<!-- Charge On Terminal Modal  -->
<p-dialog [(visible)]="chargeOnTerminalModal" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '470px'}" styleClass="no-header-modal overflow-visible" aria-label="charge-on-terminal-dialog" data-testid="charge-on-terminal-dialog">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Header -->
        <div class="surface-0 p-3 sticky left-0 top-0 w-full z-1 flex align-items-center justify-content-between border-bottom-1 border-300" data-testid="dialog-header">
            <h2 class="mb-0 text-sm line-height-1">{{'POS_DEVICE.CHARGE_ON_POS' | translate}}</h2>
            <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="chargeOnTerminalModal = false" aria-label="close-dialog" data-testid="close-dialog-button"></div>
        </div>
        <!-- Header -->
        <form [formGroup]="deviceForm" data-testid="device-form">
        <!-- Modal Content -->
        <div class="surface-100 px-3" data-testid="device-list-container">
            <ul class="list-none p-0 m-0 text-sm">
                <li class="my-3 border-1 border-primary hover:border-primary border-round surface-0 p-3" *ngFor="let device of deviceList.value" [attr.data-testid]="'device-item-' + device.device_id">
                    <div class="flex align-items-center">
                        <div class="w-2rem">
                            <img width="20" src="assets/img/icons/icon-terminal.svg" alt="Terminal Icon" data-testid="terminal-icon" />
                        </div>
                        <h6 class="text-sm mb-0 text-primary" [attr.data-testid]="'device-name-' + device.device_friendly_name">{{device.device_friendly_name}}</h6>
                    </div>
                    <div class="flex justify-content-between">
                        <ul class="list-none text-600 ml-4 pl-2">
                            <li [attr.data-testid]="'device-manufacturer-' + device.device_friendly_name">{{'POS_DEVICE.MANUFACTURER' | translate}} <strong>{{device.make}}</strong></li>
                        </ul>
                        <!-- <p-radioButton name="POSMachine" [value]="device.deviceId" (click)="selectedDevice = device"></p-radioButton> -->
                        <p-radioButton [inputId]="device.device_id" [value]="device" formControlName="selectedDevice" 
                            [attr.aria-label]="'select-device-' + device.device_friendly_name" 
                            [attr.data-testid]="'select-device-' + device.device_friendly_name"></p-radioButton>
                    </div>
                </li>
            </ul>
        </div>
        <!-- Modal Content -->

        <!-- Modal Footer -->
        <div class="p-3 sticky left-0 bottom-0 w-full z-1 border-top-1 border-300 flex align-items-center justify-content-between" data-testid="dialog-footer">
            <p-button (click)="ClosePosDevice()" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-link text-sm" aria-label="cancel" data-testid="cancel-device-selection-button"></p-button>
            <p-button (click)="SelectPosDevice()" [label]="'common.BUTTONS.BUTTON-TEXT-SAVE'  | translate" [disabled]="!deviceForm.valid" styleClass="text-sm" aria-label="save-device-selection" data-testid="save-device-selection-button"></p-button>
        </div>
        <!-- Modal Footer -->
        </form>
    </ng-template>
</p-dialog>
<!-- Charge On Terminal Modal -->
